// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stylesv2__flexIt___QpaSV {
  display: flex;
  flex-direction: column;
  white-space: nowrap;
}
.stylesv2__popoverContent___Qlx_N {
  color: #fff;
  max-width: 320px !important;
}
.stylesv2__popoverContent___Qlx_N .stylesv2__infoItem___xLlT8 {
  margin-bottom: 8px;
}
.stylesv2__popoverContent___Qlx_N .stylesv2__infoItem___xLlT8:last-child {
  margin-bottom: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/components/components/Search/SearchResults/ProductInfoPopover/stylesv2.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AADF;AAIA;EACE,WAAA;EACA,2BAAA;AAFF;AAAA;EAKI,kBAAA;AAFJ;AAHA;EASI,kBAAA;AAHJ","sourcesContent":["@import '../../../../../shared/variables.less';\n\n.flexIt {\n  display: flex;\n  flex-direction: column;\n  white-space: nowrap;\n}\n\n.popoverContent {\n  color: @eon-header-text-color;\n  max-width: 320px !important;\n\n  .infoItem {\n    margin-bottom: 8px;\n  }\n\n  .infoItem:last-child {\n    margin-bottom: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexIt": `stylesv2__flexIt___QpaSV`,
	"popoverContent": `stylesv2__popoverContent___Qlx_N`,
	"infoItem": `stylesv2__infoItem___xLlT8`
};
export default ___CSS_LOADER_EXPORT___;
